import { render, staticRenderFns } from "./AdsStats.vue?vue&type=template&id=27abd39d&scoped=true"
import script from "./AdsStats.vue?vue&type=script&scoped=true&lang=js"
export * from "./AdsStats.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./AdsStats.vue?vue&type=style&index=0&id=27abd39d&prod&scoped=true&lang=css"
import style1 from "./AdsStats.vue?vue&type=style&index=1&id=27abd39d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27abd39d",
  null
  
)

export default component.exports